import { Backdrop, Button, CircularProgress, Divider, Grid, Paper, Typography } from '@mui/material';
import { Input } from 'components/layout';
import { HeadlinePage, TableCustom } from 'components/common';
import { useRole, useUser } from 'components/hooks';
import { PERMISSIONS, ROUTES } from 'consts';
import { formatProjectItems, rolePolicies } from 'helpers';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useStyle } from './styles';
import { Global } from '@emotion/react';
const GLOBAL_PERMISIONS = [
  {
    view: "macros",
    isVisible: false,
    isExecute: false
  },
  {
    view: "inventories",
    isVisible: false,
    isEdit: false,
    isCreate: false,
    isDelete: false
  },
  {
    view: "credentials",
    isVisible: false,
    isEdit: false,
    isCreate: false,
    isDelete: false
  },
]

/*
  Full admin 
  ----------
  Projects
  Companies
  User
  Rol
  Configuration
*/
export default function RoleFormDumb({ defaultValues, handleOnSubmit, isEdit }) {

  const { isLoaded, getKeysPermissions,  permissionKeys} = useRole();
  const [t] = useTranslation();
  const classes = useStyle();
  const { parameters } = useUser();
  const projects = formatProjectItems(parameters);
  const [permissionsState, setPermissionsState] = useState([]);
  const [contentTable, setContentTable] = useState(makeRows(PERMISSIONS));
  const [contentGlobalTable, setContentGlobalTable] = useState(makeRows(GLOBAL_PERMISIONS));
  const permissionRef = useRef();
  const finalizeButton = useRef();
  const methods = useForm({
    defaultValues: useMemo(() => {
      return defaultValues;
    }, [defaultValues])
  });
  const { handleSubmit, reset, control, getValues, watch, setValue } = methods;
  const watchProject = watch('project');

  useEffect(() => {
    getKeysPermissions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const makeContentToShow = (permissionSaved) => {
    const per = JSON.parse(JSON.stringify(PERMISSIONS));
    return per.map( (p,index)  => {
      if (permissionSaved[index]){
        Object.keys(p).map(key => {
          if (key !== 'view') {
            p[key] = permissionSaved[index][key];
          }
        })
        return {...p}
      }
      else{
        console.log("xxxxxxxxxxx",permissionSaved)
      }
    });
  }

   useEffect(() => {
    if (isEdit) {
      if (defaultValues.permissions.length > 1) {
        setPermissionsState(defaultValues.permissions);
        setContentTable(makeRows(makeContentToShow(defaultValues.permissions[0].permissions)));

        let globalPerm = defaultValues.permissions.filter((item)=> item.projectId == -1);
        if (globalPerm.length>0){
          globalPerm = globalPerm[0];
          setContentGlobalTable(makeRows(globalPerm.permissions))
        }

      }
      reset(defaultValues);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValues]);


  useEffect(() => {
    onChangeProyect(watchProject);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchProject]);

  const fields = [
    { policy: rolePolicies.name },
    { policy: rolePolicies.description },
  ];

  const setValuesPermission = (view, value) => {
    if (view.hasOwnProperty('isVisible')) view['isVisible'] = value;
    if (view.hasOwnProperty('isEdit'))    view['isEdit']    = value;
    if (view.hasOwnProperty('isCreate'))  view['isCreate']  = value;
    if (view.hasOwnProperty('isDelete'))  view['isDelete']  = value;
    if (view.hasOwnProperty('isExecute')) view['isExecute'] = value;
    return view;
  };

   const selectAllPermission = (event) => {
    const newContent = [...contentTable];
    newContent.forEach(content => {
      setValuesPermission(content.actions, getValues('selectAll'))
    });
    setContentTable(newContent);
  }

  const selectAll = {
    id: 'selectAll',
    name: 'selectAll',
    input: 'checkbox',
    label: 'userList.form.selectAll.label',
    onChange: selectAllPermission
  };

  const columns = [
    { label: t('common.components.table.col.view'), key: 'view' },
    {
      label: t('common.components.table.col.action'),
      key: 'actions',
      type: 'permissions'
    },
  ];

  function makeRows(permissionSaved) {
    return (permissionSaved.map(p => ({
      view: t(`common.permissionLabels.${p.view}`),
      actions: {...p}
    })));
  }

  const onChangeProyect = (project) => {
    setValue('selectAll', false);
    const projectFound = permissionsState.find(p => p.projectId === project);
    if (projectFound) {
      setContentTable(makeRows(makeContentToShow(projectFound.permissions)));
    } else {
      setContentTable(makeRows(PERMISSIONS));
    }
  }

  const handleSubmitPermission = (event) => {
    event.preventDefault();
    const projectIdSelected = getValues('project');
    const proyectSelected = projects.find(p => p.value === projectIdSelected);
    let permissionsToSave = JSON.parse(JSON.stringify(permissionsState));
    const find = p => p.projectId === Number(proyectSelected.value)
    for (var i = 0; i <= permissionKeys.length - 1; i++) {
      const inputKeys = permissionKeys[i];
      const value = event.target.elements[inputKeys].value === 'true';
      const keys = inputKeys.split('-');
      const index = permissionsToSave.findIndex(find);
      if (index > -1) {
        const findView = per => (per.view === keys[0]);
        let viewIndexFound =  permissionsToSave[index].permissions.findIndex(findView);
        if (viewIndexFound > -1) {
          permissionsToSave[index].permissions[viewIndexFound][keys[1]] = value;
        } else {
          permissionsToSave[index].permissions.push(
            { ...PERMISSIONS.find(p => p.view === keys[0]), [keys[1]]: value }
          )
        }
      } else {
        const proyect = {
          projectId: proyectSelected.value,
          projectName: proyectSelected.label,
          permissions: [
            { ...PERMISSIONS.find(p => p.view === keys[0]), [keys[1]]: value }
          ]
        }
        permissionsToSave.push(proyect)
      }
    };
    setPermissionsState(permissionsToSave);
    const permissionsContent = permissionsToSave.find(find);
    setContentTable(makeRows( makeContentToShow(permissionsContent.permissions )));
  }

  const prepareData = (data) => {
    const dataToSave = {
      roleId: data.id,
      roleName: data.name,
      roleDescription: data.description,
      permission: [...permissionsState]
    };
    dataToSave.permission = dataToSave.permission.filter((item)=> item.projectId != -1);


    const globalPermisions = {
      projectId : -1,
      projectName: 'GLOBAL',
      permissions: [...GLOBAL_PERMISIONS]
    };
    for (const i in GLOBAL_PERMISIONS) {
      const perm  = GLOBAL_PERMISIONS[i];
      const permisionId = perm.view;
      for (const item in perm) {
        if(item != 'view'){
          const val = document.getElementById(`${permisionId}-${item}`).value == 'true';
          console.log(permisionId, item,val);
          globalPermisions.permissions[i][item] = val;
        }
      }
      
    }
    dataToSave.permission.push(globalPermisions);
    handleOnSubmit(dataToSave);
  }

  return (
   <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoaded.post || isLoaded.put}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      <HeadlinePage
        title={isEdit ? 'roleEdit.headline' : 'roleCreate.headline'}
        goBack={ROUTES.ROLE_LIST}
      />

      <Paper className={classes.paperStyle}>
        <FormProvider { ...methods }>

            <Typography variant="h6" sx={{ padding: '8px 0px' }}>
              {t('roleList.form.title')}
            </Typography>
            <form onSubmit={handleSubmit(prepareData)}>
              <Grid container spacing={2}>
                {fields.map((field) => (
                  <Grid item xs={12} sm={12} md={6} lg={6} key={field.policy.id}>
                    <Input
                      {...field.policy}
                      control={control}
                      options={field.options}
                      sx={{ width: '100%' }}
                    />
                  </Grid>
                ))}
              </Grid>
              <button
                type='submit'
                ref={finalizeButton}
                style={{ display: 'none' }}
              ></button>
            </form>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Divider/>
            </Grid>

            <Grid item xs={12} sm={12} md={6} lg={6}>
              <Typography variant="h6" sx={{ padding: '8px 0px' }}>
                {t('roleList.form.subtitleGlobal')}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <form id="globalPermissions">
                  <TableCustom
                    columns={columns}
                    content={contentGlobalTable}
                  />
              </form>
                
            </Grid>

            <Grid container spacing={2} sx={{ alignItems: 'flex-end' }}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Divider/>
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Typography variant="h6" sx={{ padding: '8px 0px' }}>
                  {t('roleList.form.subtitle')}
                </Typography>

                <Input
                  { ...rolePolicies.project }
                  control={ control }
                  options={ projects }
                  sx={{ width: '100%' }}
                />
              </Grid>


              <Grid item xs={12} sm={12} md={6} lg={6}>
                <Input
                  {...selectAll}
                  control={ control }
                />
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={12}>
                <form onSubmit={handleSubmitPermission}>
                  <input
                    type='submit'
                    value='submit'
                    ref={permissionRef}
                    style={{ display: 'none' }}
                  ></input>
                  <TableCustom
                    columns={columns}
                    content={contentTable}
                  />
                </form>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Button
                  variant="outlined"
                  onClick={() => permissionRef.current.click()}
                >
                  {t('roleList.components.submitPermissionProyect')}
                </Button>
            </Grid>


            <Grid container sx={{ mt: 4 }}>
              <Grid item md={2} lg={3} />
              <Grid item xs={12} sm={12} md={8} lg={6}>
                <Button variant="contained" sx={{ width: '100%' }} type='submit' onClick={() => finalizeButton.current.click()}>
                  {isEdit ? t('roleEdit.components.submit') : t('roleCreate.components.submit')}
                </Button>
              </Grid>
              <Grid item md={2} lg={3} />
            </Grid>
        </FormProvider>
      </Paper>
   </>
  )
}
